import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import Icon from '../Icon';
import DropdownButtonContext from './Context';
var defaultIconStyle = {
  fontSize: '1rem',
  marginRight: 4
};
/**
 * @param {import('./types').DropdownButtonEntryProps<any>} props
 **/

var DropdownButtonEntry = React.forwardRef(function (props, ref) {
  /**@type {import('./types').DropdownButtonEntryProps<any>} */
  var option = props.option;

  var _React$useContext = React.useContext(DropdownButtonContext),
      _onClick = _React$useContext.onClick;

  if (option === 'separator') return React.createElement(Divider, null);

  var value = option.value,
      label = option.label,
      icon = option.icon,
      rest = _objectWithoutProperties(option, ["value", "label", "icon"]);

  var iconEl = null;

  if (icon) {
    if (typeof icon === 'string') {
      iconEl = React.createElement(Icon, {
        type: icon,
        style: defaultIconStyle
      });
    } else {
      iconEl = React.createElement(Icon, Object.assign({}, icon, {
        style: _objectSpread({}, defaultIconStyle, icon.style)
      }));
    }
  }

  return React.createElement(MenuItem, Object.assign({
    ref: ref
  }, rest, {
    onClick: function onClick(e) {
      return _onClick(e, option);
    }
  }), iconEl, option.label);
});
export default DropdownButtonEntry;